import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase/firebase";
import { collection, addDoc } from "firebase/firestore";

export default function Teachers() {
    const navigate = useNavigate();

    return (
        <div className="">

        </div>
    );
}